import { GET_USERS, CREATE_USER, EDIT_USER } from './user.types';

export const userActions = {
  getUsers: () => ({ type: GET_USERS }),
  createUser: (data) => ({ type: CREATE_USER, payload: data }),
  editUser: (id, data) => ({ type: EDIT_USER, payload: { id, data } }),
};
